import { AttributionTable } from './attribution-table';

export { AttributionTable };
